import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import { Icon, Text } from 'components/common/Elements/Elements';

import classes from './Policy.module.scss';

const Policy = data => {
  const {
    data: { name, logicOperator, resultOperator }
  } = data;

  const { t } = useTranslation('activity');

  const setDescription = (logicOperator, resultOperator) => {
    if (logicOperator === 'or') {
      if (resultOperator) {
        return t('activity:platform.ALLOW_WHEN_SOME_MATCH');
      } else {
        return t('activity:platform.DENY_WHEN_SOME_MATCH');
      }
    } else {
      if (resultOperator) {
        return t('activity:platform.ALLOW_WHEN_ALL_MATCH');
      } else {
        return t('activity:platform.DENY_WHEN_ALL_MATCH');
      }
    }
  };

  return (
    <div className={classes.box}>
      <div className={classes.icon_wrap}>
        <Icon size="16px" icon="group" />
      </div>
      <Text className={classes.text} weight="b">
        {name ? name : ''}
        <Text size={2} className={classes.description}>
          {setDescription(logicOperator, resultOperator)}
        </Text>
      </Text>
    </div>
  );
};

Policy.propTypes = {
  data: PropTypes.object
};

export default Policy;
